import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Soundium free-gift strip — add-to-cart that behaves exactly like the theme's
 * native add-to-cart: it dispatches the real CartLinesUpdateEvent so the
 * cart-drawer auto-opens and refreshes (no page reload needed). SND-12138.
 */
if (!window.__sndGiftInit) {
  window.__sndGiftInit = true;

  const sectionIds = () => {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  };

  const refreshCart = async () => {
    const c = /** @type {any} */ (document.querySelector('cart-items-component'));
    if (c && typeof c.fetchCartData === 'function') {
      await customElements.whenDefined('cart-items-component');
      return c.fetchCartData();
    }
    const url = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    const r = await fetch(`${url}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart fetch ${r.status}`);
    return r.json();
  };

  const addUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

  function addGift(box, btn) {
    const variant = box.dataset.variant;
    if (!variant || btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    box.classList.add('is-adding');

    const txt = btn.querySelector('.snd-gift__add-txt');
    const original = box.dataset.textDefault || (txt ? txt.textContent : '');

    // Tell the theme a line is being added — this is what auto-opens the drawer.
    const deferred = CartLinesUpdateEvent.createPromise();
    box.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variant, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }], sections: sectionIds() }),
    })
      .then((r) => r.json())
      .then(async (response) => {
        if (response.status) throw new Error(response.description || response.message || 'Cart error');

        const cart = await refreshCart();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'soundium-free-gift',
            sourceId: 'soundium-free-gift',
            itemCount: 1,
            sections: response.sections,
            didError: false,
          },
        });

        box.classList.remove('is-adding');
        box.classList.add('is-added');
        if (txt) txt.textContent = box.dataset.textAdded || 'Added';
        setTimeout(() => {
          box.classList.remove('is-added');
          if (txt) txt.textContent = original;
          btn.dataset.busy = '0';
        }, 2600);
      })
      .catch((err) => {
        try { deferred.reject(err); } catch (e) {}
        box.classList.remove('is-adding');
        btn.dataset.busy = '0';
        console.error('[soundium-free-gift]', err);
      });
  }

  document.addEventListener('click', (e) => {
    const t = /** @type {Element} */ (e.target);
    const btn = t.closest && t.closest('.snd-gift [data-add]');
    if (!btn) return;
    const box = btn.closest('.snd-gift');
    if (!box) return;
    e.preventDefault();
    addGift(box, btn);
  });
}
